import type { WizardFormData } from '../page';
import { useSystemSettings } from '../../../hooks/useSystemSettings';

interface Props {
  formData: WizardFormData;
  onFinish: () => void;
  loading?: boolean;
}

const highlights = [
  { icon: 'ri-dashboard-line', text: 'Dashboard personalizado preparado' },
  { icon: 'ri-shield-check-line', text: 'Conta criada com segurança total' },
  { icon: 'ri-focus-3-line', text: 'Objetivos configurados com sucesso' },
];

export const WizardStep6 = ({ formData, onFinish, loading = false }: Props) => {
  const firstName = formData.name || 'usuário';
  const { settings } = useSystemSettings();
  const platformName = settings.platform_name || 'nossa plataforma';

  return (
    <div className="p-8 text-center">
      {/* Success animation */}
      <div className="w-20 h-20 mx-auto bg-emerald-100 rounded-full flex items-center justify-center mb-6">
        <div className="w-14 h-14 bg-emerald-500 rounded-full flex items-center justify-center">
          <i className="ri-check-line text-white text-3xl" />
        </div>
      </div>

      <h2 className="text-3xl font-800 text-gray-900 mb-2">
        Tudo pronto, {firstName}! 🎉
      </h2>
      <p className="text-gray-500 text-[15px] leading-relaxed max-w-sm mx-auto mb-6">
        Sua conta foi criada com sucesso. Agora você tem tudo que precisa para
        organizar sua vida financeira.
      </p>

      {/* Plan badge */}
      <div className={`inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6 ${
        formData.plan === 'paid'
          ? 'bg-amber-100 text-amber-700 border border-amber-200'
          : 'bg-gray-100 text-gray-600 border border-gray-200'
      }`}>
        <i className={formData.plan === 'paid' ? 'ri-vip-crown-line' : 'ri-user-line'} />
        <span className="text-sm font-600">
          {formData.plan === 'paid' ? 'Plano Premium ativado!' : 'Plano Gratuito ativo'}
        </span>
      </div>

      {/* Highlights */}
      <div className="space-y-3 mb-8 text-left max-w-sm mx-auto">
        {highlights.map((item, i) => (
          <div key={i} className="flex items-center gap-3 p-3 bg-emerald-50 rounded-xl">
            <div className="w-8 h-8 flex items-center justify-center bg-emerald-100 rounded-lg shrink-0">
              <i className={`${item.icon} text-emerald-600 text-base`} />
            </div>
            <span className="text-sm font-500 text-gray-700">{item.text}</span>
            <i className="ri-check-line text-emerald-500 ml-auto text-base" />
          </div>
        ))}
      </div>

      <button
        onClick={onFinish}
        disabled={loading}
        className="w-full h-12 bg-emerald-500 hover:bg-emerald-600 disabled:opacity-70 disabled:cursor-not-allowed text-white font-700 rounded-xl transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-2 text-[15px]"
      >
        {loading ? (
          <>
            <i className="ri-loader-4-line animate-spin text-base" />
            Abrindo seu dashboard...
          </>
        ) : (
          <>
            <i className="ri-dashboard-line text-base" />
            Acessar meu Dashboard
            <i className="ri-arrow-right-line text-base" />
          </>
        )}
      </button>

      <p className="mt-4 text-xs text-gray-400">
        Bem-vindo à família {platformName}! 💚
      </p>
    </div>
  );
};